import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, inView = false, className = "" }) => {
  const props = inView
    ? { whileInView: "visible", viewport: { once: true, amount: 0.1 } }
    : { animate: "visible" };
  return (
    <motion.span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]" initial="hidden" {...props}>
      <motion.span
        className={`block ${className}`}
        variants={{ hidden: { y: "110%", rotate: 4 }, visible: { y: "0%", rotate: 0 } }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

export const SectionHead = ({ eyebrow, title, sub, tone = "dark", testid, align = "left", eyebrowClass = "bg-sun" }) => {
  const color = tone === "light" ? "text-white" : "text-ink";
  const subColor = tone === "light" ? "text-white/85" : "text-ink/75";
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testid}>
      <Reveal y={20}>
        <span className={`inline-flex items-center gap-2 rounded-full sticker-sm px-4 py-1.5 text-xs sm:text-sm font-extrabold uppercase tracking-wider text-ink ${eyebrowClass}`}>
          {eyebrow}
        </span>
      </Reveal>
      <h2 className={`font-display font-bold mt-5 text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight ${color}`}>
        <MaskLine inView>{title}</MaskLine>
      </h2>
      {sub && (
        <Reveal delay={0.15} y={20}>
          <p className={`mt-4 text-base sm:text-lg leading-relaxed ${subColor}`}>{sub}</p>
        </Reveal>
      )}
    </div>
  );
};
